import { Text, useTexture } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { Box, Flex, useReflow } from "@react-three/flex";
import React from "react";
import * as THREE from "three";
import { question } from "../../../../../../Types";
import { textMeshMaterial } from "../XRImagePop";

const img = new Image();

const QuestionContainer = (props: {
  question: question;
  answerIds: number[];
  setAnswers: setAnswers;
  imageData: string | undefined;
}) => {
  const { question, answerIds, setAnswers, imageData } = props;

  const reflow = useReflow();

  useFrame(() => {
    reflow();
  });

  const [ratio, setRatio] = React.useState<number | undefined>(undefined);

  React.useEffect(() => {
    //@ts-ignore
    img.src = null;
    setRatio(undefined);

    if (imageData) {
      img.src = imageData;
      img.onload = () => {
        setRatio(img.naturalWidth / img.naturalHeight);
        reflow();
      };
    }
  }, [setRatio, imageData, reflow]);

  const flexDir: "column" | "row" = React.useMemo(() => {
    reflow();
    if (!!ratio && ratio < 1) return "row";
    else return "column";
  }, [ratio, reflow]);
  return (
    <Box
      marginTop={1}
      alignContent={"flex-start"}
      width={"100%"}
      centerAnchor
      // flexDir={"column"}
      // dir={ratio === undefined || ratio > 1 ? "column" : "row"}
      // align={ratio === undefined || ratio > 1 ? "center" : "flex-start"}
    >
      <Flex
        centerAnchor
        align={"center"}
        justify={"center"}
        flexDirection={flexDir}
      >
        <Box centerAnchor margin={1}>
          <Text
            textAlign="left"
            material={textMeshMaterial}
            renderOrder={3}
            maxWidth={30}
          >
            {question.questionText}
          </Text>
        </Box>

        <Box centerAnchor>
          {imageData && (
            <ImageMesh imageData={imageData} ratio={ratio ?? 1}></ImageMesh>
          )}
        </Box>
      </Flex>

      {/* <Box>
          <Drei.Text textAlign="left" maxWidth={30}>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officia
            reiciendis explicabo magnam quis quod cum adipisci, ab totam quo
            tenetur veniam! Cumque esse quidem accusamus ullam tempora ab
            consequuntur similique!
          </Drei.Text>
          <Box>
            <CloseBtn scale={1}></CloseBtn>
          </Box>
        </Box> */}

      {/* <Box width={"100%"} dir={"row"} justify={"center"}>
            <Box>
              <Drei.Text
                material={textMeshMaterial}
                maxWidth={ratio === undefined || ratio > 1 ? 30 : 10}
                overflowWrap="break-word"
                renderOrder={3}
              >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo
                perspiciatis animi voluptates ex, vero recusandae ullam quia
                tenetur eum culpa suscipit sed magnam consectetur quae, minima vel
                non esse quis.
                {question.questionText}
              </Drei.Text>
            </Box>
            <Box centerAnchor flexShrink={2}>
              <CloseBtn scale={1} />
            </Box>
          </Box> */}
      {/* {ratio && imageData && (
            <Box flexGrow={1}>
              <ImageMesh imageData={imageData} ratio={ratio} />
            </Box>
          )} */}
    </Box>
  );
  {
    /* 
        <Box>
          <AnswersWrapper
            setAnswers={setAnswers}
            question={question}
            answerIds={answerIds}
          />
        </Box> */
  }
};

export default QuestionContainer;

const ImageMesh = (props: { imageData: string; ratio: number }) => {
  const map = useTexture(props.imageData);

  const width: () => number = React.useCallback(() => {
    if (props.ratio > 1) return 20;
    else return props.ratio * 15;
  }, [props.ratio]);

  const height: () => number = React.useCallback(() => {
    if (props.ratio < 1) return 15;
    else return 20 / props.ratio;
  }, [props.ratio]);

  const reflow = useReflow();
  useFrame(() => {
    reflow();
  });

  return (
    <mesh
      // visible={false}

      renderOrder={4}
      geometry={new THREE.PlaneGeometry(width(), height())}
      material={
        new THREE.MeshBasicMaterial({
          map: map,
          transparent: true,
          depthTest: false,
        })
      }
    />
  );
};

type setAnswers = React.Dispatch<React.SetStateAction<number[]>>;
